import React from "react";
import { useNavigate } from "react-router-dom";

/* js imports */
import useCheckPathName from "../utils/useCheckPathname";

/* Comp Imports */
import Rainbow from "../components/Rainbow";
import GrassButterfly from "../components/GrassButterfly";
import InsideTents from "../components/InsideTents";
import BackArrow from "../components/BackArrow";
import PageTransition from "../components/PageTransition";
import Flags from "../components/Flags";
import Clouds from "../components/Clouds";
import MainDisclaimerModal from "../components/modals/MainDisclaimerModal";

const InnerTents = () => {
  useCheckPathName();
  const navigate = useNavigate();
  const handleRedirect = (pageName) => {
    navigate(pageName);
  };
  return (
    <>
      <PageTransition />
      <div className="page-main-wrapper">
        <BackArrow handleRedirect={handleRedirect} linkName="/" />
        <Clouds />
        <Rainbow />
        <Flags aboveTentClass="games-flag" />
        <Flags aboveTentClass="recipes-flag" />
        <Flags aboveTentClass="videos-flag" />
        <GrassButterfly />
        <InsideTents handleRedirect={handleRedirect} />
        <MainDisclaimerModal />
      </div>
    </>
  );
};

export default InnerTents;
